<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SelectInput from 'dashboard/components-next/select/Select.vue';

export default {
  components: {
    LoadingState,
    SettingsFieldSection,
    NextButton,
    SelectInput,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedBotId: null,
    };
  },
  computed: {
    ...mapGetters({
      bots: 'wgptBots/getBots',
      uiFlags: 'wgptBots/getUIFlags',
    }),
    currentInboxId() {
      return this.inbox?.id || this.$route.params.inboxId;
    },
    activeBot() {
      return this.$store.getters['wgptBots/getActiveBot'](this.inbox.id);
    },
  },
  watch: {
    activeBot() {
      this.selectedBotId = this.activeBot.id;
    },
  },
  mounted() {
    this.fetchBotData();
  },

  methods: {
    fetchBotData() {
      this.$store.dispatch('wgptBots/get');
      this.$store.dispatch('wgptBots/fetchBotInbox', this.inbox.id);
    },
    async updateActiveBot() {
      try {
        await this.$store.dispatch('wgptBots/setBotInbox', {
          inboxId: this.inbox.id,
          // Added this to make sure that empty values are not sent to the API
          botId: this.selectedBotId ? this.selectedBotId : undefined,
        });
        useAlert(this.$t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(this.$t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.ERROR_MESSAGE'));
      }
    },
    async disconnectBot() {
      try {
        await this.$store.dispatch('wgptBots/disconnectBot', {
          inboxId: this.inbox.id,
        });
        useAlert(
          this.$t(
            'WGPT_BOTS.INBOX_BOT_CONFIGURATION.DISCONNECTED_SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        useAlert(
          error?.message ||
            this.$t(
              'WGPT_BOTS.INBOX_BOT_CONFIGURATION.DISCONNECTED_ERROR_MESSAGE'
            )
        );
      }
    },
  },
};
</script>

<template>
  <div class="mx-6 max-w-4xl">
    <LoadingState v-if="uiFlags.isFetching || uiFlags.isFetchingBot" />
    <form v-else @submit.prevent="updateActiveBot">
      <SettingsFieldSection
        :label="$t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.TITLE')"
        :help-text="$t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.DESC')"
        class="[&>div]:!items-start"
      >
        <SelectInput
          v-model="selectedBotId"
          :placeholder="
            $t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.SELECT_PLACEHOLDER')
          "
          :options="bots.map(bot => ({ value: bot.id, label: bot.name }))"
        />
        <template #extra>
          <div class="grid grid-cols-1 lg:grid-cols-8 mt-3">
            <div class="col-span-1 lg:col-span-2 invisible" />
            <div class="col-span-1 lg:col-span-6 flex gap-2 mx-1">
              <NextButton
                type="submit"
                :label="$t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.SUBMIT')"
                :is-loading="uiFlags.isSettingBot"
              />
              <NextButton
                type="button"
                :disabled="!selectedBotId"
                :is-loading="uiFlags.isDisconnecting"
                faded
                ruby
                @click="disconnectBot"
              >
                {{ $t('WGPT_BOTS.INBOX_BOT_CONFIGURATION.DISCONNECT') }}
              </NextButton>
            </div>
          </div>
        </template>
      </SettingsFieldSection>
    </form>
  </div>
</template>
